import React, { FC } from "react";
import { useField } from "formik";
import { useGetCountriesOptions } from "../../../Functional/locations/useGetCountriesOptions";
import { SelectFormik } from "../SelectFormik/SelectFormik";
import { COUNTRIES_WITH_STATE_PROVINCE } from "../../../../constants/countriesWithStateProvince";
interface Props {
  name: string;
  label: string;
  placeholder?: string;
  searchableBySearchbox?: boolean;
}

const SelectCountryFormik: FC<React.PropsWithChildren<Props>> = ({
  name,
  label,
  placeholder,
  searchableBySearchbox,
}) => {
  const { countries, isLoading } = useGetCountriesOptions({
    shouldIncludeStates: true,
  });

  const [, , helpers] = useField("region");

  const handleClearRegion = () => {
    if (!COUNTRIES_WITH_STATE_PROVINCE.includes(name)) {
      helpers.setValue("");
    }
  };

  if (isLoading) return null;

  return (
    <SelectFormik
      name={name}
      label={label}
      placeholder={placeholder}
      options={countries}
      searchableBySearchbox={searchableBySearchbox}
      onClearRegion={handleClearRegion}
    />
  );
};

export default SelectCountryFormik;
